import { render, staticRenderFns } from "./AegClaimFacts.vue?vue&type=template&id=0826596c"
import script from "./AegClaimFacts.vue?vue&type=script&lang=js"
export * from "./AegClaimFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports